import { ToastContainer } from "react-toastify";
import styled from "styled-components";
import Express from "@Meridian-Developers/meridian-ui/middleware_controller";
import styleWrap from "../globalHelpers/GlobalStyleWrapper";

const createToastContainer = async () => {
    const component = await Express.callAsyncPublic("fetch-component", {
        componentName: "toast",
    });
    const styledComponent = styleWrap(component);

    return styled(ToastContainer).attrs({ ...component.attributes })`
        .Toastify__toast-container {
            ${styledComponent.containerStyle}
        }
        .Toastify__toast {
            ${styledComponent.defaultStyle}
        }
        .Toastify__toast--error {
            ${styledComponent.errorStyle}
        }
        .Toastify__toast--warning {
            ${styledComponent.warningStyle}
        }
        .Toastify__toast--success {
            ${styledComponent.successStyle}
        }
        .Toastify__toast-body {
            ${styledComponent.bodyStyle}
        }
        .Toastify__progress-bar {
            ${styledComponent.progressBarStyle}
        }
    `;
};

export default createToastContainer;
